export default __webpack_public_path__ + "static/media/multiple-option-join.d4d7045a.png";